import React from 'react';

import {SampleRoleParty} from 'constants/SampleStatusConstants';
import PartyList from 'ui-library/PartyList';

interface Props {
  users?: Array<SampleRoleParty>;
}

export default function SampleRoleUsers(props: Props): JSX.Element {
  if (props.users == null || props.users.length === 0) {
    return <span className="u-faded">No value</span>;
  } else {
    return <PartyList parties={props.users} maxParties={1} useAvatar={true} />;
  }
}
